
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy, signal } from '@angular/core';
import { EstablishmentsForCategorieData } from '../establishments-for-categorie/interface/establishments-for-categorie.interface';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CreateSlugService } from '../../core/service/create-slug.service';
import { AppState } from '../../store/app.state';
import { EstablishmentsGralListService } from './service/establishments-gral-list.service';
import { NavigateEstablishment } from '../../core/interfaces/navigate-for-categorie-establishment/navegiate-for-categorie.establishment.service';
import { CategoriesGralComponent } from "../../shared/components/categories-gral/categories-gral.component";
import { EstablishemntsGeneralComponent } from "../establishemnts-general/establishemnts-general.component";
import { ArrowBackComponent } from "../../shared/components/arrow-back/arrow-back.component";

@Component({
  selector: 'establishments-gral',
  imports: [CategoriesGralComponent, EstablishemntsGeneralComponent, ArrowBackComponent],
  templateUrl: './establishments-gral.component.html',
  styleUrl: './establishments-gral.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstablishmentsGralComponent implements OnInit, OnDestroy {


  establishments = signal<EstablishmentsForCategorieData[]>([]);
  isLoading: boolean = true;
  categorieID: number = 0;
  private destroy$ = new Subject<void>();
  private loading = new BehaviorSubject<boolean>(false);
  constructor(private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private createSlugService: CreateSlugService,
    private establishmentsGralListService: EstablishmentsGralListService,
    private store: Store<AppState>


  ) {

  }

  ngOnInit(): void {
    this.route.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      this.categorieID = +params['id']; // Convert string to number
      this.loadEstablishmentsGral();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  loadEstablishmentsGral(): void {
    this.store.select(state => state.location).pipe(
      takeUntil(this.destroy$)
    ).subscribe(location => {
      this.isLoading = true;
      this.cdr.detectChanges();

      const body: NavigateEstablishment = {
        type: this.categorieID,
        latitude: location.latitude.toString(),
        longitude: location.longitude.toString()
      }
      this.establishmentsGralListService.loadListEstablishmentsGral(body).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (response) => {
          // console.log('Establishments response:', response);
          if (response && response.data) {
            this.establishments.set(response.data);
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading establishments:', error);
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
    });
  }
    private createSlug(text: string): string {
    if (!text) return '';
    return this.createSlugService.createSlug(text);
  }

 async navigateToProducts(event: { id_restaurant: number, name_restaurant: string }): Promise<void> {


    try {
      this.loading.next(true);
      const slug = this.createSlug(event.name_restaurant);
      await this.router.navigate(['/products-establishment', event.id_restaurant, slug]);
    } catch (error) {
      console.error('Error al navegar a productos:', error);
      // Intento de fallback a la ruta sin slug si falla
      try {
        await this.router.navigate(['/products-establishment', event.id_restaurant]);
      } catch {
        console.error('Falló también la navegación de fallback');
      }
    } finally {
      this.loading.next(false);
      this.cdr.markForCheck();
    }
  }
}
